import React from "react";
import { useMediaQuery } from "react-responsive";
import { usePathname } from "next/navigation";
import CarConnectDesktop from "./desktop/";
import CarConnectMobile from "./mobile/";
import { BannerSectionProps } from "@/app/interface/components";
import CarConnect from "@/app/components/CarsComponents/CarConnect/desktop";

const ALLOWED_MODELS = ["corolla", "sw4", "hilux", "corolla-cross"];

const CarConnectSection: React.FC = (props) => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const pathname = usePathname();
  const currentModel = pathname?.split("/").pop()?.toLowerCase();

  if (!currentModel || !ALLOWED_MODELS.includes(currentModel)) {
    return null;
  }

  return (
    <section className="py-8 m-auto px-4 md:py-12 md:px-6 text-black">
      {isDesktop ? (
        <CarConnectDesktop {...props} />
      ) : (
        <CarConnectMobile {...props} />
      )}
    </section>
  );
};

export default React.memo(CarConnectSection);
